<template>
  <div class="section_main">
    <div class="section_cont swiper_cont">
      <div class="videoContainer">
        <video
          class="fullscreenVideo"
          id="bgVid"
          playsinline=""
          autoplay=""
          muted=""
          loop=""
        >
          <source src="../assets/img/video.mp4" type="video/mp4" />
        </video>
      </div>
      <div class="c-w1200 swiper_text">
        <div class="swiper_title">数字化+智慧化</div>
        <div class="swiper_title">一站式系统解决方案</div>
      </div>
    </div>

    <div class="section_cont">
      <div class="c-w1200">
        <h3>数字化+智慧化 一站式系统解决方案</h3>
        <h6>以科技创新为支撑，互联网为核心，数据为导向，助力各行业深远发展</h6>

        <div class="desc_cont">
          <p>康陶科技致力于帮助企业通过数字化解决各种难题</p>
          <p>推动各种大中小型企业进行数字化转型，让组织高效运转、加速创新。</p>
        </div>
      </div>
    </div>

    <div class="section_cont" id="more">
      <div class="c-w1200">
        <h3>更多服务功能 提供全方位助力</h3>

        <div class="more_cont">
          <ul>
            <li>
              <img src="@/assets/img/img_01.png" alt="" />
              <h4>信息化数据解决方案</h4>
            </li>
            <li>
              <img src="@/assets/img/img_02.png" alt="" />
              <h4>专业教研系统服务</h4>
            </li>
            <li>
              <img src="@/assets/img/img_03.png" alt="" />
              <h4>金融技术服务咨询</h4>
            </li>
          </ul>
          <h6>更多优质服务，敬请期待~</h6>
        </div>
      </div>
    </div>

    <div class="section_cont" id="companyProfileCon">
      <div class="c-w1200">
        <h3>为什么选择我们</h3>
        <h6>针对企业痛点逐个击破</h6>

        <div class="spot_cont">
          <div
            class="Pain-spot"
            v-for="(item, index) in painSpotList"
            :key="'pain_' + index"
          >
            <img :src="item.path" alt="" />
            <h4>{{ item.title }}</h4>
            <p>{{ item.desc }}</p>
            <p>{{ item.desc2 }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="section_cont" id="aboutCon">
      <div class="c-w1200">
        <h3>科技创新 走向智能</h3>
        <div class="support_cont">
          <h2>
            康陶科技是一家专业的解决方案提供平台，致力于通过科技创新，互联网核心技术，数据为导向，助力各行业深远发展。
          </h2>
          <h2>
            推动各种大中小型企业进行数字化转型，从而让组织高效运转、加速创新、走向智能。
          </h2>
          <ol>
            <li v-for="(itewm, index) in supportList" :key="'support_' + index">
              <h4>{{ itewm.name }}</h4>
              <p class="telephone">{{ itewm.telephone }}</p>
              <p v-if="itewm.email">{{ itewm.email }}</p>
              <p v-if="itewm.address">{{ itewm.address }}</p>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper";
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);
import "swiper/swiper-bundle.css";
export default {
  name: "pageHome",
  props: {
    msg: String,
  },
  components: {
    // Swiper,
    // SwiperSlide,
  },
  data() {
    return {
      painSpotList: [
        // {
        //   path: require("@/assets/img/icon_01.png"),
        //   title: "招人难招人贵",
        //   desc: "劳动密集型行业离职率高",
        //   desc2: "靠传统招聘不仅慢而且招聘难",
        // },
        // {
        //   path: require("@/assets/img/icon_02.png"),
        //   title: "人员流动大",
        //   desc: "员工入职身份未经验证，低龄、",
        //   desc2: "超龄、违法人员上岗时有发生",
        // },
        {
          path: require("@/assets/img/icon_03.png"),
          title: "企业展示度不足",
          desc: "依赖传统传播方式",
          desc2: "无法完善的企业官网",
        },
        // {
        //   path: require("@/assets/img/icon_04.png"),
        //   title: "考勤点分散",
        //   desc: "纸制考勤耗费大量人力物力",
        //   desc2: "人员出勤状况无法实时掌握",
        // },
        {
          path: require("@/assets/img/icon_05.png"),
          title: "供货商对接难",
          desc: "通过微信群管理，效率低下",
          desc2: "易出错、易漏发、无报表",
        },
        {
          path: require("@/assets/img/icon_06.png"),
          title: "信息化程度低",
          desc: "公司通告，公司最新动态，公告信息",
          desc2: "无法及时传达各个层级",
        },
      ],
      supportList: [
        {
          name: "邢台康陶信息技术服务有限公司",
          telephone: "17603197571",
          address: "河北省邢台市襄都区火炬街道办事处永安路48号设计小镇19号楼211室",
        },
        {
          name: "客服支持",
          telephone: "17603197571",
          email: "wuhaoran@kangtaoyun.com",
        },
        {
          name: "商务合作",
          telephone: "17603197571",
          email: "wuhaoran@kangtaoyun.com",
        },
      ],
      activeSlide: 0,
      scrollTop: 0,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    };
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
      new swiper(".swiper-container", {
        slidesPerView: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      });
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
  watch: {
    $route: {
      handler(val, oldval) {
        console.log(val); //新路由信息
        console.log(oldval); //老路由信息
        console.log(val.hash.substring(1));
        if (document.getElementById(val.hash.substring(1))) {
          document.getElementById(val.hash.substring(1)).scrollIntoView({
            behavior: "smooth", //平滑滚动
          });
        }
        if (this.scrollTop == 0) {
          this.$router.push("/");
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    gotoDetails(Id) {
      this.$router.push("/customer/" + Id);
    },
    gotoProductDetails(Id) {
      this.$router.push("/product/" + Id);
    },
    scrollEvent($event) {
      console.log($event);
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scrollTop = scrollTop;
    },
  },
  mounted() {
    let moreDivOffsetTop = document.getElementById("more").offsetTop;
    this.moreDivOffsetTop = moreDivOffsetTop;
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
@import url("../assets/css/common.css");

.section_cont:nth-child(even) {
  background: #fff;
}
.section_cont:nth-child(odd) {
  background: #f7f9fc;
}
/* 基础描述 */
.swiper_cont {
  background: url("../assets/img/video.mp4") no-repeat !important;
  background-size: 100% !important;
}
.videoContainer {
  position: absolute;
  width: 100%;
  height: 565px;
  overflow: hidden;
  z-index: -100;
}

.videoContainer:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  z-index: -1;
  bottom: 0;
  left: 0;
  background: rgba(25, 29, 34, 1);
}
video {
  position: absolute;
  width: 100%;
  display: block;
  z-index: -1;
  bottom: 0;
  left: 0;
  right: 0;
}

.swiper_text {
  padding-top: 245px;
  padding-bottom: 200px;
}
.swiper_title {
  font-size: 48px;
  color: #fff;
}
.swiper_title:nth-child(1) {
  padding-bottom: 20px;
}
.section_cont h3 {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  padding-top: 75px;
  padding-bottom: 25px;
}
.section_cont h6 {
  font-size: 16px;
  text-align: center;
}
.desc_cont {
  padding-top: 70px;
  padding-bottom: 120px;
}
.desc_cont p {
  font-size: 18px;
  text-align: center;
  padding-bottom: 15px;
}
/* 核心 */
.core_cont {
  padding-top: 95px;
  padding-bottom: 150px;
}
.core_cont dl {
  display: flex;
  align-content: center;
  justify-content: space-between;
  padding-bottom: 60px;
}
.core_cont dl dt {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.core_cont dl dt img {
  height: 100px;
}
.core_cont dl dd {
  width: 80%;
  position: relative;
}
.core_cont dl dd h4 {
  font-size: 22px;
  color: #555555;
  margin-bottom: 30px;
  line-height: 22px;
}
.core_cont dl dd h5 {
  font-size: 16px;
  color: #555555;
  line-height: 35px;
}
.core_btn {
  position: absolute;
  right: 0;
}
.core_btn .ant-btn-primary {
  background: #3f72fd;
}
/* 更多 */
.more_cont {
  padding-top: 80px;
  padding-bottom: 100px;
}
.more_cont ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8%;
  margin-bottom: 40px;
}
.more_cont ul li {
  width: 30%;
  padding: 4%;
  list-style: none;
  border: 1px solid #ccc;
  border-radius: 10px;
}
.more_cont ul li h4 {
  font-size: 22px;
  color: #555555;
}
.more_cont ul li img {
  width: 45px;
  height: 45px;
  margin-bottom: 30px;
}

/* 客户案例 */
.case_cont {
  padding-top: 90px;
  padding-bottom: 100px;
  overflow: hidden;
}
.case_cont:deep(.swiper-wrapper) {
  z-index: 0 !important;
  width: auto !important;
}

.case_cont .swiper-container {
  position: unset !important;
}
.case_cont .swiper-container .swiper-slide {
  width: 31.33% !important;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 10px;
  float: left;
  padding: 4% 2% 3% 2%;
  box-sizing: border-box;
  margin-right: 2%;
}
.case_cont .swiper-container .swiper-slide h4 {
  font-size: 18px;
  color: #555555;
  padding-bottom: 20px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.case_cont .swiper-container .swiper-slide p {
  height: 155px;
  font-size: 16px;
  line-height: 30px;
  margin-bottom: 20px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  /*autoprefixer: off;*/
  /*autoprefixer: on;*/
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
/* 痛点 */
.spot_cont {
  padding: 90px 80px 0 80px;
  overflow: hidden;
}
.Pain-spot {
  width: 33%;
  float: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;
}
.Pain-spot img {
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
}
.Pain-spot h4 {
  font-size: 22px;
  margin-bottom: 20px;
  font-weight: bold;
}
.Pain-spot p {
  font-size: 16px;
  color: #555555;
  line-height: 25px;
}
/* 科技技术支持 */
.support_cont {
  padding-top: 90px;
  padding-bottom: 130px;
  overflow: hidden;
}
.support_cont h2 {
  font-size: 22px;
  padding-bottom: 35px;
  line-height: 30px;
}
.support_cont ol {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.support_cont ol li {
  width: 32%;
  background: #ffffff;
  border-radius: 10px;
  padding: 4% 3% 4% 3%;
}
.support_cont ol li h4 {
  font-size: 22px;
  color: #555555;
  padding-bottom: 28px;
}
.support_cont ol li p {
  font-size: 16px;
  color: #333333;
}
.support_cont ol li p.telephone {
  padding-bottom: 20px;
}

:deep(.swiper-pagination) {
  bottom: 40px !important;
  height: 10px !important;
  width: 100% !important;
  z-index: 0 !important;
}

.swiper-pagination :deep(.swiper-pagination-bullet) {
  width: 30px !important;
  height: 10px !important;
  background: rgba(63, 114, 253, 0.3) !important;
  border-radius: 3px !important;
  margin-left: 10px !important;
}

.swiper-pagination :deep(.swiper-pagination-bullet-active) {
  width: 30px !important;
  height: 10px !important;
  background: #3f72fd !important;
  border-radius: 3px !important;
  margin-left: 10px !important;
}
</style>
